// components/InfoRow.tsx
import { FC } from "react";

interface InfoRowProps {
  label: string;
  value?: string | number | null;
}

const InfoRow: FC<InfoRowProps> = ({ label, value }) => {
  return (
    <div className="row">
      <div className="col-6 px-3">
        <label className="form-label">{label}:</label>
      </div>
      <div className="col-6">
        <p>{value ? value : 'N/A'}</p>
      </div>
    </div>
  );
};

export default InfoRow;
